import { usePreviewImageContext } from './preview-image-context';
import styles from './styles.module.scss';
import { useEffect, useRef } from 'react';
import ImageGallery, { ReactImageGalleryItem } from 'react-image-gallery';
import 'react-image-gallery/styles/scss/image-gallery.scss';
import ReactPlayer from 'react-player';

export const PreviewImageComponent = () => {
  const imageGalleryRef = useRef<any>(null);
  const imageGalleryContainerRef = useRef<HTMLDivElement>(null);
  const { previewImages, openIndex, showPreviewImage } = usePreviewImageContext();

  useEffect(() => {
    if (previewImages && previewImages.length > 0 && imageGalleryContainerRef.current?.style.display == 'none') {
      imageGalleryContainerRef.current!.style.display = 'block';
      imageGalleryRef.current?.toggleFullScreen();
    }
  }, [previewImages]);

  const emptyImage = '/media/images/stub_auto.png';

  return (
    <div style={{ position: 'absolute', inset: '0', display: 'none', zIndex: 1060 }} ref={imageGalleryContainerRef}>
      <button
        type="button"
        className={styles.closePreview}
        onClick={() => {
          imageGalleryRef.current?.toggleFullScreen();

          imageGalleryContainerRef.current!.style.display = 'none';
          document.getElementsByTagName('body')[0].style.overflow = 'auto';
          document.getElementsByTagName('html')[0].style.overflow = 'auto';
          showPreviewImage(undefined);
        }}
      >
        x
      </button>
      <ImageGallery
        ref={imageGalleryRef}
        lazyLoad={true}
        showPlayButton={false}
        showThumbnails={false}
        useBrowserFullscreen={false}
        showFullscreenButton={false}
        startIndex={openIndex}
        items={
          previewImages?.map((x) => {
            const item: ReactImageGalleryItem = {
              original: x.fileUrl ?? emptyImage,
              thumbnail: emptyImage
            };

            if (x.isVideo === true) {
              item.renderItem = RenderVideo;
            }
            return item;
          }) ?? []
        }
        onScreenChange={(fullScreen) => {
          if (fullScreen) {
            document.getElementsByTagName('body')[0].style.overflow = 'hidden';
            document.getElementsByTagName('html')[0].style.overflow = 'hidden';

            return;
          }
        }}
      />
    </div>
  );
};

const RenderVideo = (item: ReactImageGalleryItem) => {
  return (
    <ReactPlayer
      url={item.original}
      height="94vh"
      width="70%"
      playing={true}
      controls={true}
      style={{ margin: '0 auto', display: 'block' }}
    />
  );
};
